// extracted by mini-css-extract-plugin
export default {"pin":"pinned-image-styles_pin__gxXE5","imageContainer":"pinned-image-styles_imageContainer__dGCsv"};